import './InitialStep.scss';

import { IconDownload } from '@hulu-react-style-components/icons';
import { bem } from 'mission-control-common-components';

import Button from '../../../../../common/Button';
import Loader from '../../../../../common/Loader';
import {
  BUILD_CUSTOM_SCHEDULE_TEXT,
  CUSTOM_PACING_LANDING_STEP_TEXT,
  DOWNLOAD_CUSTOM_PACING_TEMPLATE,
  PAST_CUSTOM_PACING_REPORTS_LABEL,
  SET_SCHEDULE_TEXT,
  UPLOAD_CSV_TEXT,
  VIEW_REPORTS,
} from '../constants';
import CustomPacingScheduleHeader from '../CustomPacingScheduleHeader';
import { useCustomPacingScheduleContext } from '../CustomPacingScheduleProvider/CustomPacingScheduleProvider';
import DefaultContentWrapper from '../DefaultContentWrapper/DefaultContentWrapper';
import { Step } from '../types';
import { useDownloadCustomPacingTemplate } from './hooks';

const [block, element] = bem('custom-pacing-schedule-initial-step');

const InitialStep = (): React.JSX.Element => {
  const { goToStep, initiateFlow } = useCustomPacingScheduleContext();
  const { loading, handleDownload } = useDownloadCustomPacingTemplate();

  const onCSVUploadClick = (): void => {
    initiateFlow(Step.CSVUpload);
    goToStep(Step.CSVUpload);
  };

  const onSetScheduleClick = (): void => {
    goToStep(Step.SetCPSchedule);
    initiateFlow(Step.SetCPSchedule);
  };

  const onViewReportsClick = (): void => {
    goToStep(Step.ReportList);
  };

  return (
    <div data-testid="initial-step">
      <CustomPacingScheduleHeader confirmButtonDisabled={true} />
      <DefaultContentWrapper>
        <div data-testid="custom-pacing-schedule-initial-step" className={block()}>
          <p className={element('title')}>{BUILD_CUSTOM_SCHEDULE_TEXT}</p>
          <p className={element('subtitle')}>{CUSTOM_PACING_LANDING_STEP_TEXT}</p>
          <div className={element('select-section')}>
            <Button variant="outlined" size="large" className={element('button')} onClick={onCSVUploadClick}>
              {UPLOAD_CSV_TEXT}
            </Button>
            <span>OR</span>
            <Button variant="outlined" size="large" className={element('button')} onClick={onSetScheduleClick}>
              {SET_SCHEDULE_TEXT}
            </Button>
          </div>
          {loading ? (
            <Loader />
          ) : (
            <div
              data-testid="download-template-link"
              onClick={handleDownload}
              className={element('download-template-link')}
            >
              <IconDownload />
              <span>{DOWNLOAD_CUSTOM_PACING_TEMPLATE}</span>
            </div>
          )}
          <div className={element('reports-list-container')}>
            <div>
              <p className={element('title')}>{PAST_CUSTOM_PACING_REPORTS_LABEL}</p>
            </div>
            <Button variant="outlined" size="large" className={element('button')} onClick={onViewReportsClick}>
              {VIEW_REPORTS}
            </Button>
          </div>
        </div>
      </DefaultContentWrapper>
    </div>
  );
};

export default InitialStep;
